import { collector } from "./collector";

// Reuse the existing web-vitals dependency (v2 API: get*). These correlate
// jank/slowness with abandonment. web-vitals@2 has no INP (v3+ only).
export function startWebVitals() {
  import("web-vitals")
    .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const report = (metric) => {
        collector.track("web_vitals", {
          name: metric.name,
          value: Math.round(metric.value * 1000) / 1000,
          rating: metric.rating,
        });
      };
      if (getCLS) getCLS(report);
      if (getFID) getFID(report);
      if (getFCP) getFCP(report);
      if (getLCP) getLCP(report);
      if (getTTFB) getTTFB(report);
    })
    .catch(() => {
      /* web-vitals optional */
    });
}
